import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.colorRules.length === 0 ? _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('Common.addNew'),
      "color": _vm.color,
      "prepend-icon": "fa-plus",
      "data-cy": "add-rule-for-marker-when-empty"
    },
    on: {
      "click": _vm.addEmptyRule
    }
  }) : _vm._e(), _vm._l(_vm.colorRules, function (rule, ruleIndex) {
    return _c(VRow, {
      key: `rule_${ruleIndex}`,
      attrs: {
        "align": "center",
        "data-cy": `marker-row-${ruleIndex}`
      }
    }, [_c(VCol, [_c(VRow, {
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      attrs: {
        "cols": "auto"
      }
    }, [_c('twin-map-marker-color-picker-menu', {
      attrs: {
        "value": rule.color,
        "data-cy": `rule-${ruleIndex}-color-picker`
      },
      on: {
        "input": function ($event) {
          return _vm.updateRule(ruleIndex, 'color', $event);
        }
      }
    })], 1), _c(VCol, [_c(VSelect, {
      attrs: {
        "label": _vm.$t('Dashboards.components.twinMap.markerOptionsEditor.inputs.rule.field.label'),
        "items": _vm.ruleFields,
        "value": rule.field,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": "",
        "data-cy": `field-${ruleIndex}-selector`
      },
      on: {
        "input": function ($event) {
          return _vm.updateRule(ruleIndex, 'field', $event);
        }
      }
    })], 1)], 1), _c(VRow, [_c(VCol, {
      attrs: {
        "cols": "auto"
      }
    }, [_c(VSelect, {
      attrs: {
        "label": _vm.$t('Dashboards.components.twinMap.markerOptionsEditor.inputs.rule.operator.label'),
        "items": _vm.ruleOperators,
        "value": rule.operator,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": "",
        "data-cy": `operator-${ruleIndex}-selector`
      },
      on: {
        "input": function ($event) {
          return _vm.updateRule(ruleIndex, 'operator', $event);
        }
      }
    })], 1), _c(VCol, [_c(VTextField, {
      attrs: {
        "label": _vm.$t('Dashboards.components.twinMap.markerOptionsEditor.inputs.rule.value.label'),
        "value": rule.value,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": "",
        "data-cy": "rule-value"
      },
      on: {
        "input": function ($event) {
          return _vm.updateRule(ruleIndex, 'value', $event);
        }
      }
    })], 1)], 1)], 1), _c(VCol, {
      attrs: {
        "cols": "auto"
      }
    }, [_c(VRow, {
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, [_c('core-button', {
      attrs: {
        "title": _vm.$i18n_t('Common.delete'),
        "color": _vm.color,
        "prepend-icon": "fa-trash-alt",
        "data-cy": "delete-existing-marker"
      },
      on: {
        "click": function ($event) {
          return _vm.removeRule(ruleIndex);
        }
      }
    })], 1)], 1), _c(VRow, {
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, [_c('core-button', {
      attrs: {
        "title": _vm.$i18n_t('Common.addNew'),
        "color": _vm.color,
        "prepend-icon": "fa-plus",
        "data-cy": "add-rule-for-marker-when-existing"
      },
      on: {
        "click": _vm.addEmptyRule
      }
    })], 1)], 1)], 1)], 1);
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };